module.exports = __webpack_public_path__ + "img/bg-card.ab35770a.png";